<template>
<div class="root" :style="{backgroundColor: bgColor}">
  <div class="container" :class="{'NoMap': NoMap}">
    <div class="item logo">
      <h4>关注主办方（InfoQ）</h4>
      <div class="columns">
        <div class="column">
          <img :src="qrcodeI">
        </div>
        <div class="column">
          <img :src="qrcodeII">
        </div>
      </div>
    </div>
    <div class="item contact">
      <h4>联系我们</h4>
      <ul>
        <li v-for="contact in contacts" :key="contact.name">
          <a :href="contact.link">{{contact.name}}：{{contact.value}}</a>
        </li>
      </ul>
    </div>
    <div class="item map" v-if="!NoMap">
      <h4>交通指南</h4>
      <!-- 地图容器 -->
      <div id="allmap"></div>
    </div>
  </div>

  <slot name="mobile-footer-logo">
    <div class="display-mobile footer-imgBox">
      <img class="footer-imgBox-logo" :src="logo" alt="">
      <img class="footer-imgBox-qrcode" :src="qrcodeI" alt="">
    </div>
  </slot>

  <slot name="extra2" />

</div>
</template>

<script>
/**
 * @desc footer 组件
 */
export default {
  props: {
    bgColor: {
      type: String,
      default: ''
    },
    logo: {
      type: String
    },
    qrcodeI: {
      type: String
    },
    qrcodeII: {
      type: String
    },
    contacts: {
      type: Array,
      default: () => {
        return []
      }
    },
    map: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      NoMap: false
    }
  },
  created () {},
  methods: {
    /**
     * 设置地图信息[百度] == 当前使用
     * @param longitude 经度
     * @param latitude 纬度
     * @param query 查询链接
     */
    setMap (longitude, latitude, queryId, name, address) {
      if (window.BMap) {
        var map = new window.BMap.Map('allmap')
        // var poi = new window.BMap.Point(-121.977910, 37.395042)
        var poi = new window.BMap.Point(longitude, latitude)
        map.centerAndZoom(poi, 17)
        // map.enableScrollWheelZoom();
        var content = `
        <div style="margin:0;line-height:20px;padding:2px;">
          ${name}<br/>
          地址：${address}<br/>
        </div>
        <div style=" display:inline-block;border:1px solid #ccc; border-radius: 4px; padding:6px;">
          <a href="https://j.map.baidu.com${queryId}" style=" width=40px;  text-align: center; color: red" target="_blank">到这里去</a>
        </div>`

        // 创建检索信息窗口对象
        var searchInfoWindow = new window.BMapLib.SearchInfoWindow(map, content, {
          title: name, // 标题
          width: 290, // 宽度
          height: 105, // 高度
          panel: 'panel', // 检索结果面板
          enableAutoPan: true, // 自动平移
          searchTypes: []
        })
        var marker = new window.BMap.Marker(poi) // 创建marker对象
        marker.enableDragging() // marker可拖拽
        marker.addEventListener('click', function (e) {
          searchInfoWindow.open(marker)
        })
        map.addOverlay(marker) // 在地图中添加marker
      }
    },
    /**
     * 设置地图信息[谷歌]
     * @param longitude 经度
     * @param latitude 纬度
     * @param info 要现实的详细信息
     */
    _setMap (longitude = 116.409138, latitude = 39.995619, info, target) {
      if (window.AMap) {
        var map = new window.AMap.Map(target, {
          resizeEnable: true,
          center: [longitude, latitude],
          zoom: 16
        })
        window._map = map
        var marker = new window.AMap.Marker({
          map: map,
          position: [longitude, latitude]
        })
        map.add(marker)
        var infoWindow = new window.AMap.InfoWindow({
          isCustom: true, // 使用自定义窗体
          content: this._createInfoWindow(info.title, info.content.join('<br/>'), info.queryID),
          offset: new window.AMap.Pixel(16, -45)
        })
        // 鼠标点击marker弹出自定义的信息窗体
        window.AMap.event.addListener(marker, 'click', function () {
          infoWindow.open(map, marker.getPosition())
        })
      }
    },
    // 创建地图自定义窗体
    /**
     * @param title  标题
     * @param content 内容
     * @param queryID 查询ID
     */
    _createInfoWindow (title, content, queryID) {
      var html = `
        <div class="custom-info input-card content-window-card" 
          style="position: relative; box-shadow: none; bottom: 0; left: 0; width: auto; padding: 0;background: #fff; border: solid 1px silver;min-width: 280px;">
          <div class="info-top" style="position: relative;background: none repeat scroll 0 0 #F9F9F9;border-bottom: 1px solid #CCC;border-radius: 5px 5px 0 0;">
            <div style="display: inline-block; color: #333333; font-size: 14px; font-weight: bold; line-height: 31px; padding: 0 10px;">${title}</div>
            <img src="https://webapi.amap.com/images/close2.gif" style="position: absolute; top: 10px; right: 10px; transition-duration: 0.25s;" onClick="_map.clearInfoWindow()">
          </div>
          <div class="info-middle" style="background-color: white;font-size: 12px; padding: 10px 6px;  line-height: 20px;">
            ${content}
            <br />
            <a href="https://ditu.amap.com/detail/${queryID}" target="_blank">详细信息</a>
          </div>
          <div class="info-bottom" style="position: relative; top: 0px; margin: 0px auto; height: 0px;    width: 100%; clear: both; text-align: center;">
            <img src="https://webapi.amap.com/images/sharp.png" style="position: relative; z-index: 104;">
          </div>
        </div>
      `
      return html
    }
  },
  watch: {
    map: {
      handler: function (n) {
        let { longitude, latitude, queryId, name, address } = n
        if (!longitude || !latitude || !queryId || !name || !address) {
          this.NoMap = true
        } else {
          this.NoMap = false
          this.$nextTick(() => {
            this.setMap(longitude, latitude, queryId, name, address)
          })
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>

.root
  line-height: 1
  background-color: var(--primary-color)
  .container
    display: flex
    justify-content: space-between
    padding: 50px 0
    &.NoMap
      justify-content: flex-start
      & .item:first-child
        margin-right: 40px
    +mobile
      // background: url('./conBg.jpg') no-repeat center
  h4
    font-size: 24px
    color: $white
    padding-bottom: 10px
    margin-bottom: 25px
    border-bottom: 1px solid $white
    +mobile
      font-size: 22px
      text-align: center
      padding-bottom: 0
      margin-bottom: 30px
      border-bottom: 0
  .item
    width: 362px
    &.contact
      ul li
        font-size: 16px
        margin-bottom: 9px
        +mobile
          font-size: 14px
          margin-bottom: 18px
          padding-bottom: 12px
          border-bottom: 1px solid $white-ter
      margin-bottom: -14px
    a
      color: $white-ter
      &:hover
        color: $white
    &.logo
      img
        width: 165px
        margin-right: 15px
    +mobile
      &.logo, &.map
        display: none
      &.contact
        flex-grow: 1
      a
        color: $white
  #allmap
    width: 100%
    height: 196px
  .qiniu
    color: #d6dce3
    max-width: 1100px
    margin: 0 auto
    padding-bottom: 15px
    padding-top: 15px
    border-top: 1px solid #fff
    font-size: 14px
    +mobile
      // padding-left: 10px
      text-align: center
.footer
  +tablet
    display: none
  display: flex
  align-items: center
  justify-content: center
  padding: 30px 0
  background-color: $white
  position: relative
  img.logo
    width: 40%
    margin-right: 15%
  img.qrcode
    width: 25%

.contact-bottom.container
  display: block
  padding-top: 0
  ul
    display: flex
    justify-content: space-between
    li a
      display: flex
      align-items: center
      >img
        width: 21px
        margin-right: 5px
      h6
        font-size: 12px
        color: #d6dce3
        letter-spacing: 0.8px
        &:hover
          color: #fff
.mobile-map-wrapper
  display: none
  +mobile
    &
      display: block
  #mobile-map
    width: 100%
    height: 400px
  .mobile-map-title
    padding: 30px 0px 0px 0px
    line-height: 1
    color: #fff

.footer-imgBox
  display: flex
  justify-content: space-around
  padding-bottom: 60px
  .footer-imgBox-logo
    width: 36vw
    height: 28vw
  .footer-imgBox-qrcode
    width: 24vw
    height: 24vw
    margin-top: 10px
</style>
